<mat-form-field>
    <input
        matInput
        [placeholder]="placeholder"
        [disabled]="isDisabled"
        [ngModel]="value"
        (ngModelChange)="handleChange($event)"
        (focus)="handleFocus()" />
    <mat-hint align="start">{{ hint }}</mat-hint>
</mat-form-field>